'use client'

import { PerspectiveCamera } from '@react-three/drei'
import { useEffect, useState } from 'react'

export default function CameraSetup() {
  const [aspect, setAspect] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth / window.innerHeight : 1
  )

  useEffect(() => {
    const onResize = () => setAspect(window.innerWidth / window.innerHeight)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return <PerspectiveCamera fov={70} aspect={aspect} makeDefault />
}
